import AuthIcon from "pages/AuthenticationInner/AuthIcon";
import React from "react";
import { Link } from "react-router-dom";
import logoLight from "assets/images/logo-light.png";
import logoDark from "assets/images/logo-dark.png";
import { useLogin } from "../../hooks";
import { Loader2 } from "lucide-react";
import { BasicInput } from "Common/Components";

export const LoginView = () => {
  const { validation, success, error, errorMessage, isSubmitLogin, t } =
    useLogin();

  return (
    <React.Fragment>
      <div className="relative">
        <AuthIcon />

        <div className="mb-0 w-screen lg:mx-auto lg:w-[500px] card shadow-lg border-none shadow-slate-100 relative">
          <div className="!px-10 !py-12 card-body">
            <Link to="#">
              <img
                src={logoLight}
                alt=""
                className="hidden h-6 mx-auto dark:block"
              />
              <img
                src={logoDark}
                alt=""
                className="block h-6 mx-auto dark:hidden"
              />
            </Link>

            <div className="mt-8 text-center">
              <h4 className="mb-1 text-custom-500 dark:text-custom-500">
                {t("loginScreen.title")}
              </h4>
              <p className="text-slate-500 dark:text-zink-200">
                {t("loginScreen.disclaimer")}
              </p>
            </div>

            <form
              className="mt-8"
              id="signInForm"
              onSubmit={(event: any) => {
                event.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              {success && (
                <div
                  className="px-4 py-3 mb-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
                  id="successAlert"
                >
                  {t("loginScreen.succedLogin")}
                </div>
              )}
              {error && (
                <div
                  className="px-4 py-3 mb-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50"
                  id="successAlert"
                >
                  {t("loginScreen.ErrorLogin")} {errorMessage}
                </div>
              )}
              <BasicInput
                label={t("loginScreen.inputEmail")}
                placeholder={t("loginScreen.inputEmailPlaceholder")}
                id="email"
                name="email"
                type="text"
                value={validation.values.email}
                isError={validation.touched.email && validation.errors.email}
                errorMessage={validation.errors.email}
                onChange={(e) =>
                  validation.setFieldValue("email", e.target.value)
                }
                onBlur={validation.handleBlur}
              ></BasicInput>

              <BasicInput
                label={t("registerScreen.inputPasswordLabel")}
                placeholder={t("registerScreen.inputPasswordPlaceholder")}
                id="password"
                name="password"
                type="password"
                value={validation.values.password}
                isError={
                  validation.touched.password && validation.errors.password
                }
                errorMessage={validation.errors.password}
                onChange={(e) =>
                  validation.setFieldValue("password", e.target.value)
                }
                onBlur={validation.handleBlur}
              ></BasicInput>
              <div>
                <div className="flex items-center gap-2">
                  <input
                    id="checkboxDefault1"
                    className="size-4 border rounded-sm appearance-none bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-custom-500 checked:border-custom-500 dark:checked:bg-custom-500 dark:checked:border-custom-500 checked:disabled:bg-custom-400 checked:disabled:border-custom-400"
                    type="checkbox"
                    value=""
                  />
                  <label
                    htmlFor="checkboxDefault1"
                    className="inline-block text-base font-medium align-middle cursor-pointer"
                  >
                    Remember me
                  </label>
                </div>
              </div>
              <div className="mt-10">
                <button
                  type="submit"
                  className="w-full flex flex-row justify-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  disabled={isSubmitLogin}
                >
                  {isSubmitLogin ? (
                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                  ) : null}
                  {t("loginScreen.btnLogin")}
                </button>
              </div>

              <div className="mt-10 text-center">
                <p className="mb-0 text-slate-500 dark:text-zink-200">
                  {t("loginScreen.haveAccount").split(",")[0]}{" "}
                  <Link
                    to="/register"
                    className="font-semibold underline transition-all duration-150 ease-linear text-slate-500 dark:text-zink-200 hover:text-custom-500 dark:hover:text-custom-500"
                  >
                    {" "}
                    {t("loginScreen.haveAccount").split(",")[1]}
                  </Link>{" "}
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
